import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { FormGroup, FormBuilder, Validators, FormsModule,ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IncidentComponent } from '../layouts/incident/incident.component';
import { IncidentMessagesComponent } from '../layouts/incident/incident-messages/incident-messages.component';
import { KnowledgebaseComponent } from '../NewServiceRequest/knowledgebase/knowledgebase.component';
import { IncidentMessageDetailsComponent } from '../layouts/incident/incident-message-details/incident-message-details.component';
//import { AccordionModule,TabModule } from '@syncfusion/ej2-angular-navigations';
import { TagInputModule } from 'ngx-chips';
import { FroalaEditorModule } from 'angular-froala-wysiwyg';
import { ApiserviceService } from '../Service/apiservice.service';
import 'froala-editor/js/plugins.pkgd.min.js';
@NgModule({
  declarations: [IncidentComponent,IncidentMessagesComponent,IncidentMessageDetailsComponent,KnowledgebaseComponent],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    FormsModule,
    AngularMultiSelectModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    //AccordionModule,
    TagInputModule,
    FroalaEditorModule.forRoot(),
  ],
  providers: [
    ApiserviceService
  ],
  exports: [
    IncidentComponent,
    IncidentMessagesComponent,
    IncidentMessageDetailsComponent,
  ],
  bootstrap: [IncidentComponent],
})
export class NoteModuleModule { }
